import { connect } from 'react-redux';

import { IProps, Vacancies } from '../../components/vacancies/vacancies';

import { IStore } from '../../models/store';

const mapStateToProps = (state: IStore) => ({
  cityId: state.mainpage.regionsData.subdomainCityId,
  cityName: state.mainpage.regionsData.subdomainRegionInflectedTitleLoct,
  vacancies: state.vacancies,
});

export const VacanciesContainer = connect<IProps, {}, {}>(mapStateToProps)(Vacancies);
